export const STEG_CREDIT_OPTIONS = [5000, 6500, 7500, 10000];

/**
 * Retourne la liste des options de crédit STEG applicables à un dossier.
 * Conserve toute valeur historique existante (ex: 6 000 DT, 8 000 DT) en ajoutant le libellé "Valeur historique",
 * et désactive les options supérieures au montant total du dossier.
 *
 * @param {Number} montantTotal - Prix total du dossier
 * @param {Number|null} currentMontantSteg - Montant STEG actuel du dossier
 * @returns {Array<{value: number, label: string, disabled: boolean, isHistorical: boolean}>}
 */
export function getStegOptionsList(montantTotal = 0, currentMontantSteg = null) {
  const total = Number(montantTotal) || 0;
  const current = (currentMontantSteg !== null && currentMontantSteg !== undefined && currentMontantSteg !== '')
    ? Number(currentMontantSteg)
    : null;

  const optionsMap = new Map();

  // 1. Options standards 5000, 6500, 7500, 10000
  STEG_CREDIT_OPTIONS.forEach(opt => {
    optionsMap.set(opt, {
      value: opt,
      label: `${opt.toLocaleString('fr-FR')} DT`,
      disabled: total > 0 && opt > total,
      isHistorical: false
    });
  });

  // 2. Préservation d'une valeur historique non-standard (ex: 8000 DT)
  if (current !== null && !isNaN(current) && current > 0 && !optionsMap.has(current)) {
    optionsMap.set(current, {
      value: current,
      label: `${current.toLocaleString('fr-FR')} DT — Valeur historique`,
      disabled: false,
      isHistorical: true
    });
  }

  // 3. Trier le tableau résultant par valeur numérique
  return Array.from(optionsMap.values()).sort((a, b) => a.value - b.value);
}
